import React, { PropTypes } from 'react'

const Footer = (data) => {
  return (
    <table className="table table-condensed table-bordered">
      <tbody>
        <tr>
          <td colSpan="2"></td>
          <td className="text-center" colSpan="2">MID TERM</td>
          <td className="text-center" colSpan="2">FINAL TERM</td>
        </tr>
        <tr>
          <td width="10%">Submitted By:</td>
          <td><strong>{data.instructor}</strong></td>
          <td width="10%">Signature:</td>
          <td width="20%"></td>
          <td width="10%">Signature:</td>
          <td width="20%"></td>
        </tr>
        <tr>
          <td>Approved By:</td>
          <td><strong>{data.dean}</strong></td>
          <td>Signature:</td>
          <td></td>
          <td>Signature:</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  )
}

Footer.propTypes = {
  instructor: PropTypes.string,
  dean: PropTypes.string
}

export default Footer



// WEBPACK FOOTER //
// ./src/containers/Print/GradesSubmitted/footer.js